import React, { useState } from "react";
import { Container } from "reactstrap";
import { Lock } from "react-feather";
import { Card, Row, Col } from 'reactstrap';
import CheckMark from "./CheckMark";
import Game from "~/services/games";


const GameCard = ({item, setSelectedGame, setOverlayOpen, limits, checkLimitedGame})=> {

  const select = ()=> {
    if(item.status == 0) return;
    if(Game.checkLimitedGame(item, limits)) {
      checkLimitedGame(item);
      return;
    }
    setSelectedGame(item);
    setOverlayOpen(true);
  };

  return (
    <Container className="p-0">
      { Game.checkLimitedGame(item, limits) ? (
        <Card className="card-locked">
          <Row className="row-locked" onClick={select}>
            <Col xs={2} md={1} xl={1} className="game-lock"><Lock style={{height: "24px", width: "24px"}}></Lock></Col>
            <Col xs={2} md={1} xl={1} className="game-img"><img src={item.icon}/></Col>
            <Col xs={8} md={10} xl={10} className="game-lock-text">
              <p className="title">{item.name} - Locked</p>
              {Game.getLimititationSentence(item, limits)}
            </Col>
          </Row>
        </Card> )
        :
        (<Card className="game-card">
          <Row>
            <Col xs={2} md={1} xl={1} className="game-check"><CheckMark game={item}></CheckMark></Col>
            <Col xs={2} md={1} xl={1} className="game-img"><img src={item.icon}/></Col>
            <Col xs={8} md={10} xl={10} className="game-name" onClick={select}><p> {item.name} </p></Col>
          </Row>
        </Card> )
      }
    </Container>
  );
};

export default GameCard;
